module.exports = __webpack_public_path__ + "img/reinhardt.16d39102.png";